import camerluxLogo from "../assets/images/teams/camerlux.png";
import fpm237Logo from "../assets/images/teams/thionville.png";
import capvertLogo from "../assets/images/teams/cap-vert.png";
import hesperLogo from "../assets/images/teams/hesperange.png";
import senegalLogo from "../assets/images/teams/senegal.png";
import soudanLogo from "../assets/images/teams/soudan.png";
import gambieLogo from "../assets/images/teams/gambie.png";
import lionsLogo from "../assets/images/teams/lions.png";
import guineeLogo from "../assets/images/teams/guinee.png";
import ligueLogo from "../assets/images/logos/ligue2zeros.png";

import slide1Image from "../assets/images/home-slider/slide-1.jpg";
import slide2Image from "../assets/images/home-slider/slide-2.jpg";
import slide3Image from "../assets/images/home-slider/slide-3.jpg";
import slide4Image from "../assets/images/home-slider/slide-4.jpg";
import event1 from "../assets/images/events/event1.jpg";

export const appAssets = {
    league: {
        logo: ligueLogo,
    },
    teams: {
        camerlux: camerluxLogo,
        fpm237: fpm237Logo,
        capvert: capvertLogo,
        hesper: hesperLogo,
        senegal: senegalLogo,
        soudan: soudanLogo,
        gambie: gambieLogo,
        lions: lionsLogo,
        guinee: guineeLogo,
    },
    homeSlider: {
        slide1: slide1Image,
        slide2: slide2Image,
        slide3: slide3Image,
        slide4: slide4Image,
    },
    event: {
        event1: event1
    }
} as const;